import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

interface IAgreementNumberOfViolationsAgreementCell {
  numberOfViolations: number[];
}

export function AgreementNumberOfViolationsAgreementCell<T extends IAgreementNumberOfViolationsAgreementCell>({
  row,
}: Readonly<ITableRenderCell<T>>) {
  return <div>{row.numberOfViolations.join(', ')}</div>;
}
